import React from "react";
import styled from "styled-components";
import { Body1 } from "melodies-source/Text";
import { Button } from "melodies-source/Button";

interface Props {
  email?: string | null;
  sent: boolean;
  isSending: boolean;
  onSend: () => void;
}

/**
 * Shown when the current session can't be used for MFA enrollment
 * (auth/unsupported-first-factor). Lets the user send themselves an email login
 * link to move into an MFA-eligible session (see useMfaEnrollmentErrorHandler).
 */
export const SessionRecovery: React.FC<Props> = ({
  email,
  sent,
  isSending,
  onSend,
}) =>
  sent ? (
    <Container>
      <Body1>
        We&apos;ve sent a login link to{" "}
        {email ? <b>{email}</b> : "your email"}.
      </Body1>
      <Body1>Open that link on this device to continue setting up MFA.</Body1>
    </Container>
  ) : (
    <Container>
      <Body1>
        To set up MFA, we first need to re-verify your login. We&apos;ll send a
        login link to {email ? <b>{email}</b> : "your email"}.
      </Body1>
      <Button onClick={onSend} loading={isSending}>
        Send login link
      </Button>
    </Container>
  );

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: center;
`;
